import { IInputButtonSize } from "./types";

export const INPUT_BUTTON_SIZE: Record<IInputButtonSize, string> = {
  small: "40px",
  medium: "48px",
  large: "56px",
};

export const SVG_ICON_SIZE: Record<IInputButtonSize, string> = {
  small: "16px",
  medium: "20px",
  large: "24px",
};

export const SVG_ICON_MARGIN: Record<IInputButtonSize, string> = {
  small: "8px",
  medium: "12px",
  large: "16px",
};
